import { css } from "styled-components";
import { colors } from "utils";

// Figma's card stroke (green/950, 1px, inside): an overlay on the card's box,
// so adding it moves none of the card's content. The card must be positioned.
export const insideStroke = (radius, color = colors.nightlyWoods950) => css`
  &::after {
    border: 1px solid ${color};
    border-radius: ${radius}px;
    bottom: 0;
    content: "";
    left: 0;
    pointer-events: none;
    position: absolute;
    right: 0;
    top: 0;
  }
`;
